import { esc } from '../ui/modal';
import { t } from '../ui/lang';
import { maskSecret } from './secret';
/** "Telegram" clicker-settings tab — notification bot token. */
export async function renderTelegramTab(panel) {
    panel.innerHTML = `<div class="access-loading">${t('common.loading')}</div>`;
    let token = '';
    try {
        const r = await fetch('/api/clicker/settings');
        if (r.ok)
            token = (await r.json()).tg_bot_token ?? '';
    }
    catch { /* fall back to empty */ }
    panel.innerHTML = `
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.telegram')}</h3>
            <form class="settings-telegram-form" novalidate>
                <div class="modal__field">
                    <label>${t('clickertab.tg_bot_token')}</label>
                    <input class="settings-input tg-token" type="text" autocomplete="off" placeholder="${token ? t('clickertab.tg_token_replace_placeholder') : t('clickertab.tg_token_placeholder')}" />
                    ${token ? `<p class="settings-hint">${t('clickertab.tg_saved_token', { token: `<code>${esc(maskSecret(token))}</code>` })}</p>` : ''}
                </div>
                <button type="submit" class="modal__submit" style="margin-top:12px">${t('common.save')}</button>
            </form>
            <div class="settings-error modal__error tg-error" style="display:none"></div>
        </div>
    `;
    const form = panel.querySelector('.settings-telegram-form');
    const input = panel.querySelector('.tg-token');
    const errorEl = panel.querySelector('.tg-error');
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.style.display = 'none';
        const newToken = input.value.trim();
        // Empty input keeps the saved token (it's masked, so we never echo it back).
        if (!newToken) {
            if (!token) {
                errorEl.textContent = t('clickertab.err_token_required');
                errorEl.style.display = 'block';
                return;
            }
            const btnNoop = form.querySelector('.modal__submit');
            const orig = btnNoop.textContent;
            btnNoop.textContent = t('clickertab.unchanged');
            setTimeout(() => { btnNoop.textContent = orig; }, 1500);
            return;
        }
        const btn = form.querySelector('.modal__submit');
        btn.disabled = true;
        try {
            const r = await fetch('/api/clicker/settings', {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ tg_bot_token: newToken }),
            });
            if (!r.ok) {
                errorEl.textContent = (await r.json()).error ?? t('common.failed_to_save');
                errorEl.style.display = 'block';
                return;
            }
            void renderTelegramTab(panel);
        }
        catch {
            errorEl.textContent = t('clickertab.network_error');
            errorEl.style.display = 'block';
        }
        finally {
            btn.disabled = false;
        }
    });
}
